import React, { useMemo } from 'react';

import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { FormikHelpers, FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { initialCentroDistribuicaoValues, RequestCentroDistribuicaoProps } from 'pages/complementar/centro-distribuicao/types';

export function CentroDistribuicaoFormComp() {
    const { setContent } = useFormContext();
    const url = '/gestao/centrodistribuicao';
    const { id } = useParams();
    const { mutate } = useFormMutation();

    const handleSubmit = (values: RequestCentroDistribuicaoProps, formik: FormikHelpers<RequestCentroDistribuicaoProps>): void => {
        mutate(
            {
                url,
                idField: 'idCentroDistribuicao',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data) {
                        setContent(data);
                    }
                },
            },
        );
    };

    const validationSchema = useMemo(
        (): any =>
            Yup.object({
                dsCentroDistribuicao: Yup.string().required(),
                cdCentroDistribuicao: Yup.string().required(),
                fgAtivo: Yup.boolean().required(),
            }),
        [],
    );

    return (
        <FormPage
            title="Centro de Distribuição"
            values={initialCentroDistribuicaoValues}
            fgAtivo={false}
            onSubmit={handleSubmit}
            url={url}
            validationSchema={validationSchema}
            goBackButton
        >
            {(formik: FormikProps<RequestCentroDistribuicaoProps>) => {
                return (
                    <Block>
                        <Row>
                            {id && (
                                <Grid sx={{ flex: 1 }}>
                                    <CissTextField label="Código" value={id} disabled={true} />
                                </Grid>
                            )}

                            <Grid sx={{ flex: 1 }}>
                                <CissTextField
                                    label="Nome do centro"
                                    name="dsCentroDistribuicao"
                                    value={formik.values.dsCentroDistribuicao}
                                    error={Boolean(formik.errors.dsCentroDistribuicao)}
                                    helperText={formik.errors.dsCentroDistribuicao && String(formik.errors.dsCentroDistribuicao)}
                                    onChange={(e) => formik.setFieldValue('dsCentroDistribuicao', e.target.value)}
                                />
                            </Grid>

                            <Grid sx={{ flex: 1 }}>
                                <CissTextField
                                    disabled={Boolean(id)}
                                    label="Código de Integração"
                                    name="cdCentroDistribuicao"
                                    error={Boolean(formik.errors.cdCentroDistribuicao)}
                                    helperText={formik.errors.cdCentroDistribuicao && String(formik.errors.cdCentroDistribuicao)}
                                    value={formik.values.cdCentroDistribuicao}
                                    onChange={(e) => formik.setFieldValue('cdCentroDistribuicao', e.target.value)}
                                />
                            </Grid>
                        </Row>
                    </Block>
                );
            }}
        </FormPage>
    );
}
